import type {SimpleFond, TypeOrIdentifiedStub, UUID} from 'src/typings';
import type {GridDeleteRequest, GridEditRequest, CellModificationResponse, GridRegenerateRequest, RecordRow} from '../lib/types';
import type {AjaxService} from 'core/data-services/ajax.service';
import type {GridLayout} from 'src/features/record/field-types/types';

export class RecordGridDataService {
    public static serviceName = 'recordGridDataService';

    private readonly GRID_LAYOUT_ROUTE = 'grid/layout';
    private readonly GRID_RECORD_ROUTE = 'grid/record';
    private readonly GRID_RECORDS_ROUTE = 'grid/records';
    private readonly GRID_EDIT2_ROUTE = 'grid/edit';
    private readonly GRID_DELETE_ROUTE = 'grid/delete';
    private readonly GRID_REGENERATE_ROUTE = 'grid/regenerate';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async loadLayout(fond: TypeOrIdentifiedStub<SimpleFond>): Promise<GridLayout> {
        return this.ajaxService
            .createRequest(`${this.GRID_LAYOUT_ROUTE}/${fond.id}`)
            .get();
    }

    public async loadSingleRow(recordId: UUID): Promise<RecordRow> {
        return this.ajaxService
            .createRequest(`${this.GRID_RECORD_ROUTE}/${recordId}`)
            .get();
    }

    public async loadRows(recordIds: UUID[]): Promise<RecordRow[]> {
        return this.ajaxService
            .createRequest(`${this.GRID_RECORDS_ROUTE}`)
            .get({recordIds});
    }

    public async editCells(request: GridEditRequest): Promise<CellModificationResponse> {
        return this.ajaxService
            .createRequest(`${this.GRID_EDIT2_ROUTE}`)
            .post(request);
    }

    public async deleteCells(request: GridDeleteRequest): Promise<CellModificationResponse> {
        return this.ajaxService
            .createRequest(`${this.GRID_DELETE_ROUTE}`)
            .post(request);
    }

    public async regenerateCells(request: GridRegenerateRequest): Promise<CellModificationResponse> {
        return this.ajaxService
            .createRequest(`${this.GRID_REGENERATE_ROUTE}`)
            .post(request);
    }
}